
    import './styles.scoped.css';
    export default {
  "visible-content": "awsui_visible-content_tc96w_1ynza_185",
  "visible-content-toggle": "awsui_visible-content-toggle_tc96w_1ynza_186",
  "visible-content-groups": "awsui_visible-content-groups_tc96w_1ynza_187",
  "visible-content-group": "awsui_visible-content-group_tc96w_1ynza_187",
  "visible-content-title": "awsui_visible-content-title_tc96w_1ynza_192",
  "visible-content-group-label": "awsui_visible-content-group-label_tc96w_1ynza_202",
  "visible-content-option": "awsui_visible-content-option_tc96w_1ynza_208",
  "visible-content-option-label": "awsui_visible-content-option-label_tc96w_1ynza_221",
  "content-display-option-toggle": "awsui_content-display-option-toggle_tc96w_1ynza_412",
  "content-display-option-content": "awsui_content-display-option-content_tc96w_1ynza_416",
  "content-display-option": "awsui_content-display-option_tc96w_1ynza_412",
  "placeholder": "awsui_placeholder_tc96w_1ynza_466",
  "sorting": "awsui_sorting_tc96w_1ynza_466",
  "content-display-option-label": "awsui_content-display-option-label_tc96w_1ynza_493",
  "drag-overlay": "awsui_drag-overlay_tc96w_1ynza_500",
  "content-display": "awsui_content-display_tc96w_1ynza_412",
  "content-display-title": "awsui_content-display-title_tc96w_1ynza_533",
  "content-display-description": "awsui_content-display-description_tc96w_1ynza_542",
  "content-display-option-list": "awsui_content-display-option-list_tc96w_1ynza_550",
  "root": "awsui_root_tc96w_1ynza_557",
  "modal-root": "awsui_modal-root_tc96w_1ynza_558",
  "trigger-button": "awsui_trigger-button_tc96w_1ynza_559",
  "cancel-button": "awsui_cancel-button_tc96w_1ynza_560",
  "confirm-button": "awsui_confirm-button_tc96w_1ynza_561",
  "custom": "awsui_custom_tc96w_1ynza_562",
  "second-column-small": "awsui_second-column-small_tc96w_1ynza_566",
  "wrap-lines": "awsui_wrap-lines_tc96w_1ynza_570",
  "striped-rows": "awsui_striped-rows_tc96w_1ynza_571",
  "content-density": "awsui_content-density_tc96w_1ynza_572",
  "page-size": "awsui_page-size_tc96w_1ynza_573",
  "page-size-form-field": "awsui_page-size-form-field_tc96w_1ynza_574",
  "page-size-radio-group": "awsui_page-size-radio-group_tc96w_1ynza_575",
  "sticky-columns": "awsui_sticky-columns_tc96w_1ynza_576",
  "sticky-columns-form-field": "awsui_sticky-columns-form-field_tc96w_1ynza_577",
  "sticky-columns-radio-group": "awsui_sticky-columns-radio-group_tc96w_1ynza_578",
  "sticky-columns-first": "awsui_sticky-columns-first_tc96w_1ynza_579",
  "sticky-columns-last": "awsui_sticky-columns-last_tc96w_1ynza_580"
};
  